import { Injectable, signal } from "@angular/core";

import { Profile } from "../models/profile";

@Injectable({ providedIn: "root" })
export class MatchesService {
  readonly matches = signal<Profile[]>([]);

  addMatch(profile: Profile): void {
    const cur = this.matches();
    if (cur.some((m) => m.id === profile.id)) return;
    this.matches.set([profile, ...cur]);
  }

  clear(): void {
    this.matches.set([]);
  }
}

